// extracted by mini-css-extract-plugin
module.exports = {"leaders-board-bg":"LeadersBoard_leaders-board-bg__3Aw37","lb-root":"LeadersBoard_lb-root__Y_m4_"};